<div *ngIf="pessoas && pessoas.length" class="boxNovoBloco">
    <div class="boxNovoIndice">
        {{id}}
    </div>
    <div *ngFor="let pes of pessoas" class="boxNovo">
        <div class="boxNome">
            {{pes.nome}}
        </div>
        <div class="boxImagem">
            <img [src]="pes.foto| pipeFoto" alt="ft" style="width: 80px;height: 80px;">
        </div>
        <div class="boxFuncao">
            {{pes.funcao}}
        </div>
        <div class="boxEmail" (click)="enviarEmail(pes.email)">
            <div>
                {{pes.email.split('@')[0]}}
            </div>
            <div>
                {{'@'+(pes.email.split('@')[1])}}
            </div>
        </div>
        
        <div class="boxOrigem">
            {{pes.origem}}
        </div>
    </div>
</div>






<!-- <app-lista-arquivos categoria="atafiscal" [miniMode]="true" ></app-lista-arquivos> -->